import { render, staticRenderFns } from "./VChartRow.vue?vue&type=template&id=474b1961&scoped=true&"
import script from "./VChartRow.vue?vue&type=script&lang=ts&"
export * from "./VChartRow.vue?vue&type=script&lang=ts&"
import style0 from "./VChartRow.vue?vue&type=style&index=0&id=474b1961&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474b1961",
  null
  
)

export default component.exports